module.exports = __webpack_public_path__ + "static/capital-one-review-6bfd641fbe0947ac06c19d800f2580a1.png";